"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEstateTranslateState = void 0;
exports.defaultEstateTranslateState = {
    contact: 'Contact',
    phases: 'Phases',
    otherPhases: 'Other Phases',
    selectPhases: 'Select Phases',
    ppsf: 'Price / sqft.',
    transactions: 'Transactions',
    compareTo: 'To',
    forSale: 'For Sale',
    forRent: 'For Rent',
    viewMore: 'View More',
    facts: 'Facts',
    location: 'Location',
    follow: 'Follow',
    blockUnits: 'Blocks / Units',
    blocks: 'Blocks',
    units: 'Units',
    floors: 'Floors',
    age: 'Age',
    years: 'Years',
    schoolNet: 'School Net',
    primary: 'Primary',
    secondary: 'Secondary',
    features: 'Features',
    date: 'Date',
    property: 'Property',
    margin: 'Margin',
    price: 'Price',
    size: 'Size',
    saleable: 'Saleable',
    saleableAbbr: 'sa',
    gross: 'Gross',
    grossAbbr: 'gfa',
    transactionRecords: 'Transaction Records',
    trends: 'Trends',
    all: 'All',
    availableForSale: 'Available Listings For Sale',
    availableForRent: 'Available Listings For Rent',
    nearbyProperties: 'Nearby Properties',
    back: 'Back',
    close: 'Close',
    photos: 'Photos',
    availableListings: 'Available Listings',
    estate: 'Estate',
    phase: 'Phase',
    overview: 'Overview',
    builtYear: 'Year Built',
    built: 'Built',
};
